export interface IReportsComponents {
  ReportName: string;
  ServiceParentName: string;
  Controls: Array<IReportFilterControl>;
}
export interface IReportFilterControl {
  labelText?: string;
  placeholderText?: string;
  toolTipText?: string;
  controlName: string;
  dataSource?: any[] | null,
  unFormatedDataSource?: any[],
  valueField?: string;
  textField?: string;
  textAsValueField?: boolean;
  multipleSelect?: boolean;
  filterControlType: FilterControlType
  fieldSourceType?: FieldSourceType,
  dropdownGroupType?: DropDownGroupType,
  platformAvailable: number[];
  isDependentControl?: boolean;
  dependentControlName?: string;
  dependentFilterId?: string;
  toggleControl?: boolean;
  isDynamic?: boolean;
  isHidden?: boolean;

}

export enum FilterControlType {
  DropDown = "DropDown",
  TextBox = "TextBox",
  Date = "Date",
  CheckBox = "CheckBox",
  DateRange = "DateRange"
}
export enum FieldSourceType {
  AssetCategory = "AssetCategory",
  Country = "Country",  
  DocumentStatus = "DocumentStatus",
  FAQCategory = "FAQCategory",
  FAQSection = "FAQSection",
  Forum = "Forum",
  MessageCategory = "MessageCategory",
  Poll = "Poll",
  PortalLevel = "PortalLevel",
  PrimaryCRA = "PrimaryCRA",
  SafetyReportStatus = "SafetyReportStatus",
  SafetyReportType = "SafetyReportType",
  SiteName = "SiteName",  
  SiteRole = "SiteRole",
  Topic = "Topic",
  User = "User",
  SponsorEnterpriseUsers = "SponsorEnterpriseUsers",
  UserStatus = "UserStatus",
  TrainingActiveStatus = "TrainingActiveStatus",
  MetricsUserStatus = "MetricsUserStatus",
  ViewRequirement = "ViewRequirement",
  SignatureRequirement = "SignatureRequirement",
  Title = "Title",
  SafetyReportTitle = "SafetyReportTitle",
  AssignmentStatus = "AssignmentStatus",
  TrainingAssignmentStatus = "TrainingAssignmentStatus",
  SusarTitle = "SusarTitle",
  Country_of_Origin = "Country_of_Origin",
  Compound = "Compound",
  Study_of_Origin = "Study_of_Origin",
  Protocol_of_Origin = "Protocol_of_Origin",
  AE_Term = "AE_Term",
  Initial_Follow_up = "Initial_Follow_up",
  Global_Case_ID = "Global_Case_ID",
  Event_date = "Event_date",
  Date_Sent = "Date_Sent",  
  Visit_Type = "Visit_Type",
  Type_Abbreviation = "TypeAbbreviation",
  PostDateFrom = "PostDateFrom",
  PostDateTo = "PostDateTo",
  EventDateFrom = "EventDateFrom",
  EventDateTo = "EventDateTo",
  SafetyReportEnabledStudy = "SafetyReportEnabledStudy",
  Death_or_Life_Threatening="Death_or_Life_Threatening",
  Creation_Date = "CreationDate",
  DeclinedSiteName = "DeclinedSiteName",
  SiteType = "SiteType",
  TrainingSource = "Source",
  DelegationAction = "DelegationAction",
  OverrideAssignmentTypes = "OverrideAssignmentTypes",
  Portal = "Portal",
  FromDate = "FromDate",
  ToDate = "ToDate",
  StudyStatAssetCategory = "StudyStatAssetCategory",
  StudyStatAssetSubCategory = "StudyStatAssetSubCategory",
  StatisfactoryResponse = "StatisfactoryResponse",
  AIQuestionCategoryName = "AIQuestionCategoryName",
  }

export enum DropDownGroupType {
  Documents = "Documents",
  Teamdocument = "Teamdocument",
  Forms = "Forms",
  ebinder = "ebinder",
  Alerts = "Alerts",
  Susar = "Susar",
  Training = "Training"
}


export interface IReportGridOptions {
  PageSize: number;
  PageIndex: number;
  SortColumn: string;
  SortOrder: string;
  ReportType: number;
  ExportType: string;
  PlatFormId: number;
  PortalId: number;
}

export interface IColumnHeaders {
  Order: number;
  PreventSorting: boolean;
  field: string;
  title: string;
  type: number;
  width:number;
}

export enum DynamicSafetyReports {
  SafetyReportsCompletionDetailReport = "SafetyReportsCompletionDetailReport",
  SafetyReportsManagementReport = "SafetyReportsManagementReport",
  EnterpriseSafetyReportsCompletionDetailReport = "EnterpriseSafetyReportsCompletionDetailReport",    
  EnterpriseSafetyReportsManagementReport = "EnterpriseSafetyReportsManagementReport"  
}

export enum EnterpirseReports {
  EnterpriseSafetyReportsCompletionSummaryReport = "EnterpriseSafetyReportsCompletionSummaryReport",
  EnterpriseSafetyReportsDistributionReport = "EnterpriseSafetyReportsDistributionReport",  
  EnterpriseSiteReport = "EnterpriseSiteReport",
  EnterpriseUserReport = "EnterpriseUserReport"
  
}
